export const errorTrackIds = {
    copyRCIDOld: {
        id: 'dagligbank-error-card-old-copy-rcid',
    },
    copyRCIDNew: {
        id: 'dagligbank-error-card-new-copy-rcid',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZ3RtL3RyYWNrSURzL2Vycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRztJQUN6QixXQUFXLEVBQUU7UUFDVCxFQUFFLEVBQUUscUNBQXFDO0tBQzVDO0lBQ0QsV0FBVyxFQUFFO1FBQ1QsRUFBRSxFQUFFLHFDQUFxQztLQUM1QztDQUNKLENBQUMifQ==